import { Div, DivProps } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React, { MouseEventHandler } from 'react';
import { LabelWithTooltip } from './wrappers/inputs/withFormProps';

export interface ProsConsProps extends DivProps {
  data: string[][];
  childVariant?: string;
  onChildClick?: MouseEventHandler;
  onlyCons?: boolean;
  onlyPros?: boolean;
  onlyOptional?: boolean;
  containerProps?: DivProps;
}

export const ProsCons: React.FC<ProsConsProps> = ({
  data,
  onlyCons,
  onlyPros,
  onlyOptional,
  containerProps,
  ...restProps
}: ProsConsProps) => {
  return (
    <Div variant="prosCons" {...containerProps}>
      {data.map((group: string[], parentKey: number) => {
        let type: 'pros' | 'danger' | 'optional' | 'warning' = 'pros';
        if (onlyCons) {
          type = 'danger';
        } else if (onlyPros) {
          type = 'pros';
        } else if (onlyOptional) {
          type = 'optional';
        } else if (parentKey === 1) {
          type = 'warning';
        }

        const key = `prosCons-${parentKey}`;

        return (
          <Div key={key}>
            {group.map((item: string, childKey: number) => {
              const marginTop = parentKey === 0 && childKey === 0 ? 0 : 2;

              return (
                <ProsConsItem
                  key={`${key}-${childKey}`}
                  mt={marginTop}
                  text={item}
                  type={type}
                  {...restProps}
                />
              );
            })}
          </Div>
        );
      })}
    </Div>
  );
};

export interface ProsConsItemProps
  extends Omit<ProsConsProps, 'data' | 'id' | 'onlyCons' | 'onlyPros'> {
  text: string;
  type: 'pros' | 'danger' | 'optional' | 'warning';
  tooltip?: string;
}

export const ProsConsItem: React.FC<ProsConsItemProps> = ({
  childVariant,
  onChildClick,
  text,
  type,
  tooltip,
  ...restProps
}: ProsConsItemProps) => {
  let divColor = '';
  let iconName = '';
  let variant = '';

  switch (type) {
    case 'danger': {
      divColor = 'second.0';
      iconName = 'small-cancel';
      variant = 'dangerBig';
      break;
    }
    case 'pros': {
      iconName = 'green-check';
      variant = 'successBig';
      break;
    }
    case 'optional': {
      iconName = 'small-plus';
      variant = 'optionalBig';
      break;
    }
    case 'warning': {
      iconName = 'small-alert';
      variant = 'warningBig';
      break;
    }
  }

  return (
    <Div display="flex" {...restProps}>
      <Icon my="auto" mr={2} name={iconName} variant={variant} />
      <Div
        color={divColor}
        fontSize={2}
        my="auto"
        style={{
          cursor: onChildClick !== undefined ? 'pointer' : '',
        }}
        onClick={onChildClick}
        variant={childVariant}
      >
        {text}
        {tooltip && <LabelWithTooltip _tooltip={tooltip} />}
      </Div>
    </Div>
  );
};
